/* eslint-disable camelcase */
/**
 * ЗАВИСИМОСТИ
 */
import 'ion-rangeslider/css/ion.rangeSlider.css';
import 'ion-rangeslider/css/ion.rangeSlider.skinHTML5.css';
import Borders from './modules/borders';
// eslint-disable-next-line no-unused-vars
import ionRangeSlider from 'ion-rangeslider';
import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const observer = new Observer();

/**
 * КОМПОНЕНТ
 */
class RangeSlider {
    constructor() {
        this.rangeSlider = {};
        this.borders = new Borders();
    }

    /**
     * Инициализация слайдера
     * @param {Object} options - внешние настройки
     */
    init(options) {
        this.$wrapper = $(options.wrapper);
        // если нет настроек то получаем из дата-атрибута
        this.outerOptions = options.outerOptions || this.$wrapper.find('.j-range-slider-base').data();

        this._setOptions();
        this._initRangeSlider();
        this._getElements();
        this._bindEvents();
        this._subscribes();
        this._initBorders();
        this._initDigit();
    }

    /**
     * Установка параметров
     */
    _setOptions() {
        this.options = {
            type            : this.outerOptions.type,
            min             : this.outerOptions.min,
            max             : this.outerOptions.max,
            from            : this.outerOptions.from,
            to              : this.outerOptions.to,
            step            : this.outerOptions.step,
            min_interval    : this.outerOptions.step,
            borderMin       : this.outerOptions.borderMin,
            borderMax       : this.outerOptions.borderMax,
            digit           : this.outerOptions.digit || false,
            disable         : this.outerOptions.disable || false,
            validate        : this.outerOptions.validate,
            hide_from_to    : true,
            hide_min_max    : true,
            prettify_enabled: true,
            onStart         : (data) => {
                observer.publish('rangesliderStart', data, this);
            },
            onChange: (data) => {
                this._updateInputs(data);
                this._changeBorders(data);
                observer.publish('rangesliderChange', data);
            },
            onFinish: (data) => {
                observer.publish('rangesliderFinish', data);
            },
            onUpdate: (data) => {
                this._updateInputs(data);
                this._changeBorders(data);
                observer.publish('rangesliderChange', data);
            }
        };

        this.startOptions = this.options;
    }

    /**
     * Метод инициализирует плагин рэндж-слайдера
     */
    _initRangeSlider() {
        this.$rangeSlider = this.$wrapper.find('.j-range-slider-base');
        this.$rangeSlider.ionRangeSlider(this.options);
    }

    /**
     * Метод получает требуемые элементы
     */
    _getElements() {
        this.$inputs = this.$wrapper.find('.range-slider__input');
        this.$inputFrom = this.$inputs.first();
        this.$inputTo = this.options.type === 'double' ? this.$inputs.last() : null;
        this.slider = this.$rangeSlider.data('ionRangeSlider');
        this.id = this.slider.input.id;
        this.rangeSlider[this.id] = this.slider;
    }

    /**
     * Метод содержит в себе колбэки на события других модулей.
     */
    _subscribes() {
        // Сброс слайдеров к дефолтному состоянию при сбросе фильтра в параметрическом.
        observer.subscribe('paramfilterReset', () => {
            this._reset();
        });

        // Обновление слайдеров после получения данных от параметрического фильтра.
        observer.subscribe('parametricfilterSend', (data) => {
            this._updateBorders(data);
            this._initDigit();
        });

        observer.subscribe('parametricfilterUpdate', () => {
            this._initDigit();
        });
    }

    /**
     * Биндим события
     */
    _bindEvents() {
        this.$inputFrom.on('change', this._onInputFromChange.bind(this));

        if (this.options.type === 'double') {
            this.$inputTo.on('change', this._onInputToChange.bind(this));
        }

        this.$inputs.each((index, item) => {
            item.addEventListener('input', (event) => {
                const $target = $(event.target);
                const value = $target.val();

                this._validate($target);
                this._setDigit($target, value);
            });
        });
    }

    /**
     * Изменение инпута "от"
     * @param {Object} event - объект события
     */
    _onInputFromChange(event) {
        // конвертируем в число, т.к после добавления разрядов получаем строку
        let val = this._getNumber($(event.target).val());
        const startValue = 0;
        const oneDecimal = 1;
        const currentTo = this.slider.result.to;

        // Если это инпут с разрядами то округляем до 1 знака после запятой, а если нет то до 0
        const decimal = this.options.validate === 'number_decimal' ? oneDecimal : startValue;

        // Если это одинарный инпут то шагом до сброса к мин и макс значению будет 0
        const step = this.options.type === 'single' ? startValue : this.options.step;

        if (val < this.options.min) {
            val = this.options.min;
        } else if (val > currentTo) {
            val = currentTo - step;
        }

        val = val.toFixed(decimal);

        $(event.target).val(val);

        // Конвертируем в число с разрядами
        this._setDigit($(event.target), val);
        this._update({from: val});
    }

    /**
     * Изменение инпута "до"
     * @param {Object} event - объект события
     */
    _onInputToChange(event) {
        // конвертируем в число, т.к после добавления разрядов получаем строку
        let val = this._getNumber($(event.target).val());
        const startValue = 0;
        const oneDecimal = 1;
        const currentFrom = this.slider.result.from;
        // Если это инпут с разрядами то округляем до 1 знака после запятой, а если нет то до 0
        const decimal = this.options.validate === 'number_decimal' ? oneDecimal : startValue;

        if (val <= currentFrom) {
            val = currentFrom + this.options.step;
        } else if (val > this.options.max) {
            val = this.options.max;
        }

        val = val.toFixed(decimal);

        $(event.target).val(val);
        // Конвертируем в число с разрядами, в данном случае не используется
        this._setDigit($(event.target), val);

        this._update({to: val});
    }

    /**
     * Выбирает метод валидации.
     * @param {Object} $target - дом-элемент слайдера
     */
    _validate($target) {
        const type = this.options.validate;

        if (!type) {
            return;
        }

        switch (type) {
            case 'number':
                this._validateNumber($target);
                break;
            case 'number_decimal':
                this._validateNumberDecimal($target);
                break;
            default:
                break;
        }
    }

    /**
     * Запускает валидацию только по числам
     * @param {Object} $target - дом-элемент слайдера
     */
    _validateNumber($target) {
        const value = $target.val();
        const regex = /\d*/;

        $target.val(regex.exec(value));
    }

    /**
     * Запускает валидацию только по целым и числам с плавающей точкой
     * @param {Object} $target - дом-элемент слайдера
     */
    _validateNumberDecimal($target) {
        const value = $target.val();
        const regex = /\d*\.?\d?/g;

        $target.val(regex.exec(value));
    }

    _update(data) {
        this.slider.update(data);

        // Нужно заново переинициализировать бордеры, т.к update все вычишает
        this._initBorders();
    }

    /**
     * Обновление инпутов
     * @param {Object} data - данные рэйндж-слайдера
     */
    _updateInputs(data) {
        this.$inputFrom.val(data.from);

        this._setDigit(this.$inputFrom, data.from);

        if (this.options.type === 'double') {
            this.$inputTo.val(data.to);
            this._setDigit(this.$inputTo, data.to);
        }
    }

    /**
     * Сбрасывает range-slider до первоначального состояния
     * В параметрическом на вью не используется
     */
    _reset() {
        // Значения от и до в сдвоенном слайдере сбрасываются на мин и макс;
        // Дефолтное значение в одиночном считается макс
        const first = 0;

        // Если этот слайдер не учавствтует в поиске, то ничего делать не требуется
        if (this.slider.input.classList.contains('is-not-search')) {
            return;
        }

        if (this.options.type === 'double') {
            this.startOptions.from = this.startOptions.min;
            this.startOptions.to = this.startOptions.max;

            this.slider.inputFrom[first].setAttribute('value', this.startOptions.from);
            this.slider.inputTo[first].setAttribute('value', this.startOptions.to);
            this.$inputFrom.val(this.startOptions.from);
            this.$inputTo.val(this.startOptions.to);
        } else {
            this.startOptions.from = this.$inputFrom.attr('value');
            this.$inputFrom.attr('value', this.startOptions.from);
            this.$inputFrom.val(this.startOptions.from);
        }

        // Возвращаем слайдер на мин и макс позиции
        this.slider.update(this.startOptions);
        this._updateInputs(this.startOptions);

        // Нужно заново переинициализировать бордеры, т.к update все вычишает
        this._initBorders();
    }

    /**
     * Иницализация модуля для визуализации границ.
     */
    _initBorders() {
        // проксимуем настройки в экземпляр слайдера
        this.slider.result.borderMin = this.options.borderMin;
        this.slider.result.borderMax = this.options.borderMax;

        if (this.options.borderMin && this.options.borderMax) {
            this.borders.init(this.slider);
        }
    }

    /**
     * Изменение модуля визуализации границ при change слайдера.
     * @param {HTMLDivElement} data -  Экземпляр слайдера на котором произошло событие.
     */
    _changeBorders(data) {
        if (this.options.borderMin && this.options.borderMax) {
            this.borders.change(data);
        }
    }

    /**
     * Обновление модуля визуализации границ при получении ответа от сервера.
     * @param {object} data - Данные с бэкэнда.
     */
    _updateBorders(data) {
        data.forEach((item) => {
            for (const key in item) {
                if (Utils.keyExist(this.rangeSlider, [key])) {
                    const borderMin = item[key].borderMin;
                    const borderMax = item[key].borderMax;

                    this._update(item[key]);

                    if (borderMin && borderMax) {
                        // Обновляем требуемые для модуля 'border' дата-атрибуты;
                        this.slider.result.borderMin = borderMin;
                        this.slider.result.borderMax = borderMax;
                        this.borders.update(this.slider);
                    }
                }
            }
        });
    }

    /**
     * Метод инициализирует разряды для значений инпута
     */
    _initDigit() {
        this.$inputs.each((index, item) => {
            if (this.options.digit) {
                this._setDigit($(item));
            }
        });
    }

    /**
     * Метод устанавливает разряды для значений инпута
     * @param {Object} $input - изменяемый инпут
     * @param {String} value - значение инпута, при перемещении ручек приходит от слайдера.
     */
    _setDigit($input, value = '') {
        const type = this.options.digit;

        if (!type) {
            return;
        }

        const data = value ? value : $input.val();
        const number = this._getNumber(data);

        $input.val(Utils.convertToDigit(number));
    }

    /**
     * Конвертация из строки с разрядами в число
     * @param {String} str - значение с разрядом
     * @returns {Number} - значение без разрядов
     */
    _getNumber(str) {
        const zero = 0;

        if (!str) {
            return zero;
        }

        return Utils.convertToNumber(str);
    }
}

export default RangeSlider;
